module.exports = __webpack_public_path__ + "static/media/Xujiong.e9ef8eb6.jpg";